(function (jQuery, undefined) {
    var sm = window.sm = window.sm || {};
    var windowProxy;
    var actionQueue = [];

    if (typeof sm.portal === "undefined") {
        jQuery.extend(sm, { portal: {} });
    }
    if (typeof sm.portal.knockout === "undefined") {
        jQuery.extend(sm.portal, { knockout: {} });
    }

    // http://tech.pro/blog/1863/10-knockout-binding-handlers-i-don-t-want-to-live-without
    ko.bindingHandlers.currency = {
        update: function (element, valueAccessor, allBindingsAccessor) {
            return ko.bindingHandlers.text.update(element, function () {
                var value = +(ko.utils.unwrapObservable(valueAccessor()) || 0),
                    symbol = allBindingsAccessor().symbol || ''
                return symbol + value.toFixed(2).replace(/(\d)(?=(\d{3})+\.)/g, "$1,");
            });
        }
    };

    ko.bindingHandlers.currencyOrText = {
        update: function(element, valueAccessor, allBindingsAccessor) {
          var value = +(ko.utils.unwrapObservable(valueAccessor()));
          if(isNaN(value)) {
            return ko.bindingHandlers.text.update(element, valueAccessor, allBindingsAccessor);
          }
          else return ko.bindingHandlers.currency.update(element,valueAccessor, allBindingsAccessor);
        }
    }

    // http://jsfiddle.net/karlhorky/MzwHQ/
    ko.bindingHandlers.bindIframe = {
        init: function (element, valueAccessor) {
            function bindIframe() {
                try {
                    var iframedoc =
                        jQuery(element).contents().find('body')[0];
                } catch (e) {
                    // ignored
                }
                if (iframedoc)
                    ko.applyBindings(valueAccessor(), iframedoc);
            };
            bindIframe();
            ko.utils.registerEventHandler(element, 'load', bindIframe);
        }
    };

    ko.bindingHandlers.delayBind = {
        'update': function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
            var value = valueAccessor(), waitUntil = ko.utils.unwrapObservable(value.waitUntil);
            if (waitUntil && !element.mydelayBindInit) {
                ko.applyBindingsToNode(element, function () { return ko.bindingProvider['instance']['parseBindingsString'](value.bind, bindingContext) }, bindingContext);
                element.mydelayBindInit = true;
            }
        }
    };

    // True/False Radio Button binding - allows you to bind a True/False or Yes/No radio pair to a single boolean observable
    /// ----------------------------------------------------------------------- /// This binding is used to bind a pair of radio buttons to a boolean observable
    ko.bindingHandlers.trueFalseRadioButton =
        {
            init: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                // event handler for the element change event
                var changeHandler = function () {
                    var elementValue = jQuery(element).val();
                    var observable = valueAccessor();      // set the observable value to the boolean value of the element value
                    observable(jQuery.parseJSON(elementValue));
                };    // register change handler for element
                ko.utils.registerEventHandler(element,
                    "change",
                    changeHandler);
            },
            update: function (element, valueAccessor, allBindingsAccessor, viewModel, bindingContext) {
                var elementValue = jQuery.parseJSON(jQuery(element).val());
                var observableValue = ko.utils.unwrapObservable(valueAccessor()); if (elementValue === observableValue) {
                    element.checked = true;
                }
                else {
                    element.checked = false;
                }
            }
        };

    ko.bindingHandlers.iframeContent = {
        update: function (element, valueAccessor) {
            //Prevent interference from cke iframe
            if (jQuery(element).parents("cke_contents").length == 0) {
                var value = ko.unwrap(valueAccessor());
                element.contentWindow.document.close(); // Clear the content
                element.contentWindow.document.write(value);
            }
        }
    };

    ko.subscribable.fn.subscribeChanged = function (callback) {

        var that = this;
        // take the current value

        var savedValue = this.peek();
        return this.subscribe(function (latestValue) {
            var oldValue = savedValue;
            savedValue = latestValue;
            callback(latestValue, oldValue);
        });
    };

    ko.bindingHandlers.ckeditor = {
        init: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var options = ko.utils.extend({
                toolbar: 'basic',
                removePlugins: 'elementspath'
            }, allBindings.get('ckeditorOptions') || {
            });
            var modelValue = valueAccessor();
            var editor = CKEDITOR.replace(element, options);

            editor.on('change', function () {
                modelValue(editor.getData());
            });

            //handle disposal (if KO removes by the template binding)
            ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
                if (editor) {
                    CKEDITOR.remove(editor);
                };
            });
        },
        update: function (element, valueAccessor, allBindings, viewModel, bindingContext) {
            var editor = new CKEDITOR.dom.element(element).getEditor();
            editor.setData(ko.unwrap(valueAccessor()), null, true);
        }
    };




    // customized binding handlers to help with formatting
    ko.bindingHandlers.date = {
        // format date to dd/mm/yyyy
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor(), allBindings = allBindingsAccessor();
            var valueUnwrapped = ko.utils.unwrapObservable(value);
            var d = sm.portal.utility.formatDate(valueUnwrapped, true);
            jQuery(element).text(d);
        }
    };

    ko.bindingHandlers.dateUtc = {
        // format date to dd/mm/yyyy
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor(), allBindings = allBindingsAccessor();
            var valueUnwrapped = ko.utils.unwrapObservable(value);
            var d = sm.portal.utility.formatDate(valueUnwrapped, true, undefined, undefined, undefine, true);
            jQuery(element).text(d);
        }
    };

    ko.bindingHandlers.dateTime = {
        // format date and time to dd/mm/yyyy hh:mm am/pm
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor(), allBindings = allBindingsAccessor();
            var valueUnwrapped = ko.utils.unwrapObservable(value);
            var d = sm.portal.utility.formatDate(valueUnwrapped, true, true);
            jQuery(element).text(d);
        }
    };
    ko.bindingHandlers.dateTimeDay = {
        // format date to dd/mm/yyyy hh:mm am/pm - mon
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor(), allBindings = allBindingsAccessor();
            var valueUnwrapped = ko.utils.unwrapObservable(value);
            var d = sm.portal.utility.formatDate(valueUnwrapped, true, true, true, false);
            jQuery(element).text(d);
        }
    };
    ko.bindingHandlers.dateTimeDayLong = {
        // format date to dd/mm/yyyy hh:mm am/pm - mon
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = valueAccessor(), allBindings = allBindingsAccessor();
            var valueUnwrapped = ko.utils.unwrapObservable(value);
            var d = sm.portal.utility.formatDate(valueUnwrapped, true, true, true, true);
            jQuery(element).text(d);
        }
    };

    ko.bindingHandlers.decimal2 = {
        // format value to two decimal places
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor()),
                precision = ko.utils.unwrapObservable(allBindingsAccessor().precision) || ko.bindingHandlers.decimal2.defaultPrecision,
                formattedValue = value.toFixed(precision);

            ko.bindingHandlers.text.update(element, function () { return formattedValue; });
        },
        defaultPrecision: 2
    };

    ko.bindingHandlers.decimal3 = {
        // format value to three decimal places
        update: function (element, valueAccessor, allBindingsAccessor) {
            var value = ko.utils.unwrapObservable(valueAccessor()),
                precision = ko.utils.unwrapObservable(allBindingsAccessor().precision) || ko.bindingHandlers.decimal3.defaultPrecision,
                formattedValue = value.toFixed(precision);

            ko.bindingHandlers.text.update(element, function () { return formattedValue; });
        },
        defaultPrecision: 3
    };

    ko.bindingHandlers.VerificationLetter =
        {
            init: function (element, valueAccessor) {
                sm.portal.vm.setChange(element, valueAccessor);
            },
            update: function (element, valueAccessor) {
                sm.portal.vm.doUpdate(element, valueAccessor);
            }
        };

    // Document Upload bindings
    ko.bindingHandlers.edFormFile =
        ko.bindingHandlers.goalsFile =
        ko.bindingHandlers.formFile =
        ko.bindingHandlers.writingFile =
        ko.bindingHandlers.programPlanFile =
        ko.bindingHandlers.ugMajorFile =
        ko.bindingHandlers.teachingCertFile =
        ko.bindingHandlers.retentionFile =
        ko.bindingHandlers.interviewFile =
        ko.bindingHandlers.resumeFile =
        ko.bindingHandlers.recommendationFile =
        ko.bindingHandlers.sevisFeeFile =
        ko.bindingHandlers.cosFeeFile =
        ko.bindingHandlers.sponsorLetterFile =
        ko.bindingHandlers.petitionLetterFile =
        ko.bindingHandlers.formI540File =
        ko.bindingHandlers.formI539File =
        ko.bindingHandlers.ds2019File =
        ko.bindingHandlers.i20File =
        ko.bindingHandlers.transferFormFile =
        ko.bindingHandlers.legalStatusFile =
        ko.bindingHandlers.residentCardFile =
        ko.bindingHandlers.complianceFile =
        ko.bindingHandlers.tuitionFormFile =
        ko.bindingHandlers.bankFile =
        ko.bindingHandlers.supportFile =
        ko.bindingHandlers.passportCopyFile =
        ko.bindingHandlers.visaCopyFile =
        ko.bindingHandlers.i94CopyFile =
        ko.bindingHandlers.codeOfConductFile =
        ko.bindingHandlers.form48CFile =
        ko.bindingHandlers.releaseFormFile =
        ko.bindingHandlers.immunizationFile =
        ko.bindingHandlers.collegeFile =
        ko.bindingHandlers.highSchoolFile =
        ko.bindingHandlers.admissionsDocFile = {
            init: function (element, valueAccessor) {
                sm.portal.page.documentChecklist.setChange(element, valueAccessor);
            },
            update: function (element, valueAccessor, allBindingsAccessor, currentModel, bindingContext) {
                sm.portal.page.documentChecklist.doUpdate(element, valueAccessor, allBindingsAccessor, currentModel, bindingContext);
            }
        }

    // Localization Handlers
    //-----------------------------------------------
    ko.bindingHandlers.localize_Tooltip = {

        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {

            try {
                var obj = valueAccessor();

                if (obj) {
                    var newValue;

                    if (obj.hasOwnProperty('key') && obj.hasOwnProperty('observables')) {

                        // Use globalized string with observable value in it
                        var x = sm.portal.utility.getResourceValue(obj.key);
                        var observables = [];
                        for (i = 0; obj.observables.length > i; i++) {
                            if (sm.portal.utility.isFunction(obj.observables[i])) {
                                observables.push(ko.utils.unwrapObservable(obj.observables[i]()));
                            }
                            else {
                                observables.push(obj.observables[i]);
                            }
                        }
                        var template = sm.portal.knockout.format(x, observables);
                        newValue = template;
                        element.tooltip = template;
                    }
                    else {
                        // Replace straight text in element
                        var x = sm.portal.utility.getResourceValue(valueAccessor());
                        newValue = x;
                        element.tooltip = x;
                    }
                    sm.portal.utility.addTitleToElement(element, newValue);
                }
            }
            catch (err) {
                console.log(err.message);
            }
        },

        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {

            try {
                var obj = valueAccessor();

                if (obj) {
                    var newValue;
                    if (obj.hasOwnProperty('key') && obj.hasOwnProperty('observables')) {

                        // Use globalized string with observable value in it
                        var x = sm.portal.utility.getResourceValue(obj.key);
                        var observables = [];
                        for (i = 0; obj.observables.length > i; i++) {
                            if (sm.portal.utility.isFunction(obj.observables[i])) {
                                observables.push(ko.utils.unwrapObservable(obj.observables[i]()));
                            }
                            else {
                                observables.push(obj.observables[i]);
                            }
                        }
                        var template = sm.portal.knockout.format(x, observables);
                        newValue = template;
                        element.tooltip = template;
                    }
                    else {
                        // Replace straight text in element
                        var x = sm.portal.utility.getResourceValue(valueAccessor());
                        newValue = x;
                        element.tooltip = x;
                    }
                    sm.portal.utility.addTitleToElement(element, newValue);
                }
            }
            catch (err) {
                console.log(err.message);
            }
        }
    };

    ko.bindingHandlers.localize_Text = {

        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {

            try {
                var obj = valueAccessor();
				
				if (obj){
                var newValue;
				
                if (obj.hasOwnProperty('key') && obj.hasOwnProperty('observables')) {

                    // Use globalized string with observable value in it
                    var x = sm.portal.utility.getResourceValue(obj.key);
                    var observables = [];
                    for (i = 0; obj.observables.length > i; i++) {
                        if (sm.portal.utility.isFunction(obj.observables[i])) {
                            observables.push(ko.utils.unwrapObservable(obj.observables[i]()));
                        }
                        else {
                            observables.push(obj.observables[i]);
                        }
                    }
                    var template = sm.portal.knockout.format(x, observables);
                    newValue = template;
                    element.innerText = template;
                }
                else {
                    // Replace straight text in element
                    var x = sm.portal.utility.getResourceValue(valueAccessor());
                    newValue = x;
                    element.innerText = x;
                }

                // If the element has specified NOT to do a title, then do not put one on
                // Otherwise, add a title element with the localized text
                if (obj.hasOwnProperty('showTitle') && obj.showTitle.toLowerCase() == "true") {
                    sm.portal.utility.addTitleToElement(element, newValue);
                }
				}
            }
            catch (err) {
                console.log(err.message);
            }
        },

        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {

            try {
                var obj = valueAccessor();
				
				if (obj) {
                var newValue;
                if (obj.hasOwnProperty('key') && obj.hasOwnProperty('observables')) {

                    // Use globalized string with observable value in it
                    var x = sm.portal.utility.getResourceValue(obj.key);
                    var observables = [];
                    for (i = 0; obj.observables.length > i; i++) {
                        if (sm.portal.utility.isFunction(obj.observables[i])) {
                            observables.push(ko.utils.unwrapObservable(obj.observables[i]()));
                        }
                        else {
                            observables.push(obj.observables[i]);
                        }
                    }
                    var template = sm.portal.knockout.format(x, observables);
                    newValue = template;
                    element.innerText = template;
                }
                else {
                    // Replace straight text in element
                    var x = sm.portal.utility.getResourceValue(valueAccessor());
                    newValue = x;
                    element.innerText = x;
                }

                // If the element has specified NOT to do a title, then do not put one on
                // Otherwise, add a title element with the localized text
                if (obj.hasOwnProperty('showTitle') && obj.showTitle.toLowerCase() == "true") {
                    sm.portal.utility.addTitleToElement(element, newValue, true);
                }
				}
            }
            catch (err) {
                console.log(err.message);
            }
        }
    };

    ko.bindingHandlers.localize_HTML = {

        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {

            try {
                var obj = valueAccessor();
                var val = '';
                var prefix = '';

                if (obj.hasOwnProperty('iconClass')) {
                    prefix = '<span class="icon ' + obj.iconClass + '"></span>';
                }

                if (obj.hasOwnProperty('key')) {
                    val = sm.portal.utility.getResourceValue(obj.key);
                }
                else {
                    val = sm.portal.utility.getResourceValue(valueAccessor());
                }

                if (obj.hasOwnProperty('observables')) {

                    // Use globalized string with observable value in it
                    var observables = [];
                    for (i = 0; obj.observables.length > i; i++) {
                        if (sm.portal.utility.isFunction(obj.observables[i])) {
                            observables.push(ko.utils.unwrapObservable(obj.observables[i]()));
                        }
                        else {
                            observables.push(obj.observables[i]);
                        }
                    }
                    var template = sm.portal.knockout.format(val, observables);
                    element.innerHTML = prefix + template;
                }
                else {
                    // Replace straight text in element
                    element.innerHTML = prefix + val;
                }
            }
            catch (err) {
                console.log(err.message);
            }
        },

        update: function (element, valueAccessor, allBindingsAccessor, viewModel) {

            try {
                var obj = valueAccessor();
                var val = '';
                var prefix = '';

                if (obj.hasOwnProperty('iconClass')) {
                    prefix = '<span class="icon ' + obj.iconClass + '"></span>';
                }

                if (obj.hasOwnProperty('key')) {
                    val = sm.portal.utility.getResourceValue(obj.key);
                }
                else {
                    val = sm.portal.utility.getResourceValue(valueAccessor());
                }

                if (obj.hasOwnProperty('observables')) {

                    // Use globalized string with observable value in it
                    var observables = [];
                    for (i = 0; obj.observables.length > i; i++) {
                        if (sm.portal.utility.isFunction(obj.observables[i])) {
                            observables.push(ko.utils.unwrapObservable(obj.observables[i]()));
                        }
                        else {
                            observables.push(obj.observables[i]);
                        }
                    }
                    var template = sm.portal.knockout.format(val, observables);
                    element.innerHTML = prefix + template;
                }
                else {
                    // Replace straight text in element
                    element.innerHTML = prefix + val;
                }
            }
            catch (err) {
                console.log(err.message);
            }
        }
    };

    ko.bindingHandlers.attr_Localize_Text = {

        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {

            try {
                var obj = valueAccessor();
                if (obj.hasOwnProperty('key') && obj.hasOwnProperty('attr')) {
                    if (obj.hasOwnProperty('param')) {
                        //Convert Params to localized values
                        var params = [];
                        for (i = 0; obj.param.length > i; i++) {
                            params.push(sm.portal.utility.getResourceValue(obj.param[i]));
                        }
                        // Complete the String.Format
                        var x = sm.portal.utility.getResourceValue(obj.key);
                        var template = sm.portal.knockout.format(x, obj.param);
                        var att = document.createAttribute(obj.attr);        // Create a attribute
                        att.value = template;                                // Set the value of the attribute
                        element.setAttributeNode(att);
                    }
                    else {
                        var x = sm.portal.utility.getResourceValue(obj.key);
                        var att = document.createAttribute(obj.attr);        // Create a attribute
                        att.value = x;                                       // Set the value of the attribute
                        element.setAttributeNode(att);
                    }
                }
            }
            catch (err) {
                console.log(err.message);
            }
        },
    };

    ko.bindingHandlers.attr_Validation_Message = {
        init: function (element, valueAccessor, allBindingsAccessor, viewModel) {
            try {
                var obj = valueAccessor();
                if (obj.hasOwnProperty('obsv') && obj.hasOwnProperty('attr')) {
                    // Initial setup - will be updated by the update function
                    var att = document.createAttribute(obj.attr);
                    att.value = "";
                    element.setAttributeNode(att);
                }
            }
            catch (err) {
                console.log(err.message);
            }
        },
        update: function (element, valueAccessor) {
            try {
                var obj = valueAccessor();
                if (obj.hasOwnProperty('obsv') && obj.hasOwnProperty('attr')) {
                    var obsv = obj.obsv,
                        config = ko.validation.utils.getConfigOptions(element),
                        val = ko.utils.unwrapObservable(obsv),
                        msg = null;

                    if (obsv === null || typeof obsv === 'undefined') {
                        throw new Error('Cannot bind attr_Validation_Message to undefined value. data-bind expression: ' +
                            element.getAttribute('data-bind'));
                    }

                    var isModified = obsv.isModified && obsv.isModified();
                    var isValid = obsv.isValid && obsv.isValid();

                    var error = null;
                    if (!config.messagesOnModified || isModified) {
                        error = isValid ? null : obsv.error;
                    }

                    var errorVal = ko.utils.unwrapObservable(error());

                    // Set the attribute value to the error message
                    if (errorVal) {
                        element.setAttribute(obj.attr, errorVal);
                    } else {
                        element.removeAttribute(obj.attr);
                    }
                }
            }
            catch (err) {
                console.log(err.message);
            }
        }
    };

    // Custom Validation Rules
    ko.validation.rules['smPasswordPattern'] = {
        async: true,
        validator: function (val, otherVal, callback) {

            var url = _baseApiUri + 'api/studentportal/GetPasswordSchema?type=Pattern';
            jQuery.ajax({
                url: url,
                type: 'GET',
                dataType: 'json',
                contentType: 'application/json; charset=utf-8',
                headers: {
                    "x-api-version": '1' //,
                },
                processData: false,
                crossDomain: true,

                xhrFields: {
                    withCredentials: true
                },
                success: function (data) {
                    var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
                    if (data.Status == 'success') {
                        var msg = container.Payload.PasswordRequirementMessage;
                        var regex = eval(sm.portal.utility.formatString("/{0}/", container.Payload.PasswordRegexPattern));
                    }
                    callback({ isValid: !sm.portal.utility.isNullOrEmpty(val) && regex.test(val), message: msg });
                }
            });
        },
        message: 'My default Password Message'
    };

    // locale dependent date validation
    ko.validation.rules['smLocalDate'] = {
        async: false,
        validator: function (val) {

            if (val) {
                var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
                return moment(val, dateFormat, true).isValid();
            }

            // no validation neccesary
            return true;
        },
        message: 'Value must be a valid date'
    };

    ko.validation.rules['smValidateEffectiveFromDate'] = {
        async: false,
        validator: function (effectiveFrom, effectiveTo) {
            if (!sm.portal.utility.isNullOrEmpty(effectiveFrom) && !sm.portal.utility.isNullOrEmpty(effectiveTo)) {
                return dateValidation(effectiveFrom, effectiveTo);
            }
            return true;
        },
        message: "Effective Begin date must occur before the Effective End date."
    };
    ko.validation.rules['smValidateEffectiveToDate'] = {
        async: false,
        validator: function (effectiveTo, effectiveFrom) {
            if (!sm.portal.utility.isNullOrEmpty(effectiveFrom) && !sm.portal.utility.isNullOrEmpty(effectiveTo)) {
                return dateValidation(effectiveFrom, effectiveTo);
            }
            return true;
        },
        message: "Effective End date must occur after the Effective Begin date."
    };

    ko.validation.rules['smFutureDate'] = {
        async: false,
        validator: function (val) {
          if (val) {
            var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
            var inputDate = moment(val, dateFormat, true);
            return !moment().isAfter(inputDate);
          }
    
          return true;
        },
        message: 'The date must be later than the current date'
    };
    
    // date of birth validation
    ko.validation.rules['smDateOfBirth'] = {
        async: false,
        validator: function (val) {

            if (val) {
                var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
                var dateOfBirth = moment(val, dateFormat, true);
                var yearOfBirth = dateOfBirth.year();
                return  yearOfBirth >= 1900 && moment().isAfter(dateOfBirth);
            }

            return true;
        },
        message: 'The date must be between 1900 and the current date'
    };

    // UK postcode validation
    ko.validation.rules['ukPostcode'] = {
        async: false,
        validator: function (val) {
            if (typeof val !== 'undefined') {

                var match = val.match(
                    /([Gg][Ii][Rr] 0[Aa]{2})|((([A-Za-z][0-9]{1,2})|(([A-Za-z][A-Ha-hJ-Yj-y][0-9]{1,2})|(([A-Za-z][0-9][A-Za-z])|([A-Za-z][A-Ha-hJ-Yj-y][0-9]?[A-Za-z])))) [0-9][A-Za-z]{2})/
                );

                return match != null && val == match[0];
            }
        },
        message: 'Value must be a valid UK Postcode format: AA9 9AA or AA99 9AA or A9 9AA or A99 9AA or AA9A 9AA or A9A 9A'
    };

    // Irish postcode validation
    ko.validation.rules['iePostcode'] = {
        async: false,
        validator: function (val) {
            if (typeof val !== 'undefined') {

                var match = val.match(
                    /^[ACDEFHKNPRTVWXY]{1}[0-9]{1}[0-9W]{1}[\ \-]?[0-9ACDEFHKNPRTVWXY]{4}$/
                );

                return match != null && val == match[0];
            }
        },
        message: 'Value must be a valid Eircode format e.g A65 F4E2'
    };

    // Irish postcode validation
    ko.validation.rules['caPostcode'] = {
        async: false,
        validator: function (val) {
            if (typeof val !== 'undefined') {

                var match = val.match(
                    /^(?!.*[DFIOQU])[A-VXY][0-9][A-Z] ?[0-9][A-Z][0-9]$/
                );

                return match != null && val == match[0];
            }
        },
        message: 'Value must be a valid Canadian Postcode format e.g A1A 1A1'
    };

    ko.validation.rules['smMatchingValue'] = {
        getValue: function (o) {
            return (typeof o === 'function' ? o() : o);
        },
        validator: function (val, o) {
            var otherField = undefined;
            var data = undefined;
            if (!sm.portal.utility.isNullOrEmpty(o)) {
                data = o;
            }
            if (sm.portal.utility.isNullOrEmpty(data) && (!sm.portal.utility.isNullOrEmpty(o) && o.hasOwnProperty('params'))) {
                data = o.params;
            }
            if (data != null) {
                otherField = this.getValue(data);
            }
            if (!sm.portal.utility.isNullOrEmpty(otherField)) {
                otherField = otherField.toLowerCase();
            }
            if (!sm.portal.utility.isNullOrEmpty(val)) {
                val = val.toLowerCase();
            }
            return val == otherField;
        },
        message: 'Values do not match'
    };

    ko.validation.rules['smPasswordPattern'] = {
        getValue: function (o) {
            return (typeof o === 'function' ? o() : o);
        },
        validator: function (val, o) {
            if (o.length >= 2) {
                var re = this.getValue(o[0]);
                var msg = this.getValue(o[1]);
                var regex = sm.portal.utility.isNullOrEmpty(re) ? '' : eval(sm.portal.utility.formatString("/{0}/", re));
                this.message = sm.portal.utility.isNullOrEmpty(msg) ? '' : msg;
            }

            var required = true;
            if (o.length == 3) {
                required = this.getValue(o[2]);
            }

            if (required || !sm.portal.utility.isNullOrEmpty(val)) {
                return regex.test(val);
            }
            return true;
        },
        message: 'Password do not match'
    };

    ko.validation.rules['smPasswordLength'] = {
        getValue: function (o) {
            return (typeof o === 'function' ? o() : o);
        },
        validator: function (val, o) {
            if (o.length >= 2) {
                var min = this.getValue(o[0]);
                var msg = this.getValue(o[1]);

                this.message = sm.portal.utility.isNullOrEmpty(msg) ? '' : msg;
            }
            var required = true;
            if (o.length == 3) {
                required = this.getValue(o[2]);
            }

            if (required || !sm.portal.utility.isNullOrEmpty(val)) {
                if (val === undefined) {
                    val = "";
                }
                return val.length >= min;
            }
            return true;
        },
        message: 'Password do not match'
    };

    //Max Decimals Validator
    ko.validation.rules["maxDecimals"] = {
        validator: function (val, validate) {
            if (!val || isNaN(val)) {
                return true;
            }

            return countDecimals(val) <= validate;
        }
    };

    /**
   * Date range validator
   * 
   * Validates that supplied values are valid dates and that the 'from' date is earlier than
   * the 'to' date
   */
    ko.validation.rules['smDateRange'] = {
        validator: function (value, o) {

            // passing values?
            if (o.start() && o.end()) {

                var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
                var startDate = moment(o.start(), dateFormat, true);
                var endDate = moment(o.end(), dateFormat, true);

                // any invalid dates?
                if (!moment.isMoment(startDate) || !moment.isMoment(endDate)) {
                    // invalid
                    return false;
                }

                // end later than start
                if (moment(startDate).isBefore(endDate)) {
                    // valid
                    return true;
                }

                return false;
            }
            // validation not neccesary
            return true;
        }
    };
    /** Validate that supplied Dates are equal or not*/
    ko.validation.rules['isDatesAreEqual'] = {
        validator: function (value, o) {
            // passing values?
            if (o.start() && o.end()) {
                var dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
                var startDate = moment(o.start(), dateFormat, true);
                var endDate = moment(o.end(), dateFormat, true);
                // any invalid dates?
                if (!moment.isMoment(startDate) || !moment.isMoment(endDate)) {
                    // invalid
                    return false;
                }
                // start and end equal.
                if (!startDate.isSame(endDate)) {
                    //valid
                    return true;
                }
                return false;
            }
            // validation not neccesary
            return true;
        }
    };
    //input can be numeric or alphanumerica
    ko.validation.rules['numericOrAlphanumerica'] = {
        getValue: function (o) {
            return (typeof o === 'function' ? o() : o);
        },
        validator: function (value, o) {
            var selCountryUpper = this.getValue(o.params.SelectedCountryGID());
            if (selCountryUpper != null) {
                var selCountryGID = selCountryUpper.toLowerCase();
                if (selCountryGID === '80DDA1DB-A364-4874-A605-B9BFB34B9A4C'.toLowerCase()) {
                    // This GID is for the United States which (we think) is the only country requiring numeric postal codes, so validate numeric only here ...
                    //copied from the number rules
                    this.message = sm.portal.utility.getResourceValue(smapi.constant.validate_MustBeNumeric_Key);
                    return ko.validation.utils.isEmptyVal(value) || /^-?(?:\d+|\d{1,3}(?:,\d{3})+)?(?:\.\d+)?$/.test(value);
                }
                else {
                    //alphanumeric
                    this.message = 'The field can be alphanumeric.'
                    return true;
                }
            } else {
                this.message = "";
            }

        },

    };
    //-----------------------------------------------
    // GREAT ASYNC AJAX Validation Example
    //ko.validation.rules['smPasswordLength'] = {
    //    async: true, 
    //    validator: function (val, otherVal, callback) { 

    //        var url = _baseApiUri + 'api/studentportal/GetPasswordSchema?type=MinLength';
    //        jQuery.ajax({
    //            url: url,
    //            type: 'GET',
    //            dataType: 'json',
    //            contentType: 'application/json; charset=utf-8',
    //            headers: {
    //                "x-api-version": '1' //,
    //            },
    //            processData: false,
    //            crossDomain: true,

    //            xhrFields: {
    //                withCredentials: true
    //            },
    //            success: function (data) {
    //                var container = new smapi.access.ApiContainerModel(data.Status, data.Payload, data.ValidationTitle, data.ValidationMessages);
    //                if (data.Status == 'success') {
    //                    var msg = container.Payload.PasswordRequirementMessage;
    //                    var lngth = container.Payload.PasswordMinLength;
    //                }
    //                callback({ isValid: !sm.portal.utility.isNullOrEmpty(val) && val.length >= lngth, message: msg });
    //            }
    //        });
    //    },
    //    message: 'My default Password Message'
    //};

    // below was an attempt to get the datpicker to work... still not holding the value as you move through the steps
    // USAGE - data-bind="datepicker: DateOfBirth, datepickerOptions: { minDate: new Date('1/1/1900') }"
    // http://stackoverflow.com/questions/6612705/jquery-ui-datepicker-change-event-not-caught-by-knockoutjs
    //ko.bindingHandlers.datepicker = {
    //    init: function (element, valueAccessor, allBindingsAccessor) {
    //        //initialize datepicker with some optional options
    //        var options = allBindingsAccessor().datepickerOptions || {};

    //        var funcOnSelectdate = function () {
    //            var observable = valueAccessor();
    //            var d = $(element).datepicker("getDate");
    //            var timeInTicks = d.getTime() + (-1 * (d.getTimezoneOffset() * 60 * 1000));

    //            observable("/Date(" + timeInTicks + ")/");
    //        }
    //        options.onSelect = funcOnSelectdate;

    //        $(element).datepicker("option", "onSelect", funcOnSelectdate);

    //        //handle the field changing
    //        ko.utils.registerEventHandler(element, "change", funcOnSelectdate);

    //        //handle disposal (if KO removes by the template binding)
    //        ko.utils.domNodeDisposal.addDisposeCallback(element, function () {
    //            $(element).datepicker("destroy");
    //        });

    //    },
    //    update: function (element, valueAccessor) {
    //        var value = ko.utils.unwrapObservable(valueAccessor());

    //        //handle date data coming via json from Microsoft
    //        if (String(value).indexOf('/Date(') == 0) {
    //            value = new Date(parseInt(value.replace(/\/Date\((.*?)\)\//gi, "$1")));
    //        }

    //        current = $(element).datepicker("getDate");

    //        if (value - current !== 0) {
    //            $(element).datepicker("setDate", value);
    //        }
    //    }
    //};

    function dictionaryItem(key, value, dictionary) {
        var observableKey = new ko.observable(key);

        this.value = new ko.observable(value);
        this.key = new ko.computed({
            read: observableKey,
            write: function (newKey) {
                var current = observableKey();

                if (current == newKey) return;

                // no two items are allowed to share the same key.
                dictionary.remove(newKey);

                observableKey(newKey);
            }
        });
    }

    function countDecimals(value) {
        if ((value % 1) !== 0) {
            return value.toString().split(".")[1].length || 0;
        }
        return 0;
    }
    		
    function getValue(key, items) {
        var found = ko.utils.arrayFirst(items, function (item) {
            return item.key() == key;
        });
        return found ? found.value : null;
    }

    function format() {
        var i = arguments.length;
        if (i == 0)
            return;
        if (i == 1) {
            return arguments[0];
        }
        var str = arguments[0];

        if (i > 1 && Array.isArray(arguments[1])) {
            // Assume second argument is parameters
            var array = arguments[1];
            for (x = 0; x < array.length; x++) {
                str = str.replace(new RegExp('\\{' + (x) + '\\}', 'gm'), array[x]);
            }
        }
        else {
            while (i-- && i > 0) {
                str = str.replace(new RegExp('\\{' + (i - 1) + '\\}', 'gm'), arguments[i]);
            }
        }

        return str;
    }

    function dateValidation(effectiveFrom, effectiveTo) {
        const dateFormat = sm.resources.portalResource.getValue('DateFormatExample').toUpperCase();
        let fromDate = moment(effectiveFrom, dateFormat, true);
        let toDate = moment(effectiveTo, dateFormat, true);
        if (!moment.isMoment(fromDate) || !moment.isMoment(toDate)) {
            return false;
        }
        return !!(moment(fromDate).isBefore(toDate));
    }

    jQuery.extend(true, sm.portal.knockout, {
        getValue: getValue,
        dictionaryItem: dictionaryItem,
        format: format,
    });
})(jQuery);